import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  ApiKey,
  ApiUrl,
  _MAIN_WALLET_ID,
  SessionKey
} from "../../util/Constant";
import ApiEngine from "../../util/ApiEngine.js";
import {
  stringIsNullOrEmpty,
} from "../../util/Util";
import 'react-loading-skeleton/dist/skeleton.css'
import SpeakerIcon from "components/custom/SpeakerIcon";
import { useDispatch, useSelector } from "react-redux";
import parse from "react-html-parser";
import {
  get,
} from "lodash";
// import Marquee from "react-marquee-slider";
import Marquee from "react-fast-marquee";


const MarqueAnnoucement = () => {
  var { t } = useTranslation();
  const [content, setContent] = useState([]);
  var companyLanguages = useSelector((state) => state.appState.languages);
  const activeLanguageCode = useSelector((state) => state.languageState.languageId);
  const [activeLanguage, setActiveLanguage] = useState("");
  const [activeLanguageId, setActiveLanguageId] = useState(companyLanguages.filter(
    (x) => x.code == localStorage.getItem(SessionKey._LANGUAGE)
  )[0].id);

  async function getMarqueeTagContent() {
    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_MARQUEE_TAG_CONTENT_BY_PLATFORM +
      //"?MarqueeTagId=1" +
        "?LanguageId=" +
        ((activeLanguageId == undefined || stringIsNullOrEmpty(activeLanguageId)) ? 0 : activeLanguageId) +
      "&Platform=" +
      "MemberApp"
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      const contents = responseJson[ApiKey._API_DATA_KEY].map(option => option["content"])
      setContent(contents);
    }
  }

  useEffect(() => {
    if (companyLanguages != undefined) {
      const tempLangCode = get(companyLanguages[0], "code");
      const tempLangId = get(companyLanguages[0], "id");
      if (
        localStorage.getItem(SessionKey._LANGUAGE) &&
        localStorage.getItem(SessionKey._LANGUAGE) !== "undefined"
      ) {
        let tempLang = companyLanguages.filter(
          (x) => x.code == localStorage.getItem(SessionKey._LANGUAGE)
        )[0];

        if (tempLang != undefined) {
          setActiveLanguage(tempLang.code);
          setActiveLanguageId(tempLang.id);
        } else {
          setActiveLanguage(tempLangCode);
          setActiveLanguageId(tempLangId);
        }
      } else {
        setActiveLanguage(tempLangCode);
        setActiveLanguageId(tempLangId);
      }
    } else {
      setActiveLanguage("en");
      setActiveLanguageId(1);
    }
  }, [companyLanguages, activeLanguageCode]);

  useEffect(() => {
    if(activeLanguageId != undefined) {
      getMarqueeTagContent();
    }
  }, [activeLanguageId]);

  return (
    <>
      {content && content.length>0 && (
        <div className="t3-announcement-container mt-3">
          <div className="first hide-767">
            <SpeakerIcon />
          </div>
          <div className="second">
            <Marquee speed={60}>
              {content
                .filter(text => !stringIsNullOrEmpty(text))
                .map((text, index) => (
                  <span key={index} className="text marquee-text-item">{parse(text)}</span>
                ))}
            </Marquee>
          </div>
        </div>
      )}
    </>
  )

}

export default MarqueAnnoucement